import { Card, Col, Divider, Row, Typography } from "antd";
import { EnvironmentOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import program from "./constants";

const { Title, Text } = Typography;

const formatDateToNorwegian = (dateStr: string) => {
  const [day, month, year] = dateStr.split(".");
  const date = new Date(parseInt(year, 10), parseInt(month, 10) - 1, parseInt(day, 10));

  const weekdays = ["Søndag", "Mandag", "Tirsdag", "Onsdag", "Torsdag", "Fredag", "Lørdag"];
  const months = [
    "januar",
    "februar",
    "mars",
    "april",
    "mai",
    "juni",
    "juli",
    "august",
    "september",
    "oktober",
    "november",
    "desember",
  ];

  return `${weekdays[date.getDay()]} ${date.getDate()}. ${months[date.getMonth()]}`;
};

const ProgramSection = () => {
  const history = useHistory();

  return (
    <div style={{ padding: "50px 0" }}>
      <Title level={1} style={{ textAlign: "center", padding: "20px" }}>
        Program 2024
      </Title>
      <div style={{ width: "100%", padding: "0 50px" }}>
        <Row gutter={[16, 16]}>
          {program.map(day => (
            <Col key={day.date} md={Math.floor(24 / program.length)} sm={24} xs={24}>
              <Card style={{ background: "var(--primary-color)", color: "white", height: "100%" }}>
                <Title level={4} style={{ textAlign: "center", color: "white" }}>
                  {formatDateToNorwegian(day.date)}
                </Title>
                <Divider style={{ background: "white" }} />
                {day.events.map(event => (
                  <button
                    key={event.title}
                    type="button"
                    style={{
                      marginBottom: "20px",
                      cursor: event.relativeUrl ? "pointer" : "default",
                      background: "none",
                      border: "none",
                      padding: 0,
                      width: "100%",
                      textAlign: "left",
                    }}
                    onClick={() => {
                      if (event.relativeUrl) {
                        history.push(event.relativeUrl);
                      }
                    }}
                    onKeyDown={e => {
                      if (event.relativeUrl && (e.key === "Enter" || e.key === " ")) {
                        history.push(event.relativeUrl);
                      }
                    }}
                    disabled={!event.relativeUrl}
                  >
                    <Title level={5} style={{ color: "white", marginBottom: "5px" }}>
                      {event.start} {event.end && `- ${event.end}`}
                    </Title>
                    <Text style={{ color: "white", fontSize: "16px" }}>{event.title}</Text>
                    <br />
                    {event.location && (
                      <Text style={{ color: "white", fontSize: "16px" }}>
                        <EnvironmentOutlined /> {event.location}
                      </Text>
                    )}
                  </button>
                ))}
              </Card>
            </Col>
          ))}
        </Row>
      </div>
    </div>
  );
};

export default ProgramSection;
